// extracted by mini-css-extract-plugin
export var fadeIn = "_eg-1";
export var modalContent = "_eg-3";
export var overlay = "_eg-0";
export var popoverContent = "_eg-2";
export var results = "_eg-5";
export var searchInputWrapper = "_eg-4";